(function () {
  if (window.__mobilePeekInit) return;
  window.__mobilePeekInit = true;

  const isTouch = () => window.matchMedia('(max-width: 749px)').matches;

  document.addEventListener('click', function (e) {
    if (!isTouch()) return;

    // Ignore quick-add/buttons
    if (e.target.closest('button, [role="button"], .quick-add, .quick-add__submit')) return;

    // Product title/cover link inside card
    const link = e.target.closest(
      '.card-wrapper a.full-unstyled-link, .card a.full-unstyled-link, a.card__heading'
    );
    if (!link) return;

    const card = link.closest('.card-wrapper, .card, .grid__item');
    if (!card) return;

    // Spotlight nests images like: .card__media > .media > img,img
    const media = card.querySelector('.card__media .media');
    if (!media) return;

    const imgs = media.querySelectorAll('img');
    if (imgs.length < 2) return; // need a 2nd image to peek

    const now = Date.now();
    const lastPeek = Number(card.dataset.peekTs || 0);

    // First tap within window => peek instead of navigate
    if (now - lastPeek > 1200) {
      e.preventDefault();
      card.classList.add('product-card--peek');
      card.dataset.peekTs = String(now);
      setTimeout(() => card.classList.remove('product-card--peek'), 1200);
      return;
    }

    // Second tap within 1.2s: allow normal navigation
  }, true);
})();
